$(document).on("click",".field_set-optionList",function() {
  if($(this).hasClass('it_on')){
    $(this).removeClass('it_on');
  }else{
    $(this).addClass('it_on');
  }
});





$(document).on("click", ".dropdown_list li", function () {
  
  var value = $(this).data("title"); // e.g. "B1"
  var fullText = $(this).text().trim(); // e.g. "B1: 70x100 cm"

  // Highlight the selected list item
  $(this).siblings("li").removeClass("text_select");
  $(this).addClass("text_select");

  // Find the correct wrapper scope
  var $fieldSet = $(this).closest(".field_set-optionList");
  var $variantWrapper = $(this).closest(".variant-wrapper");

  // Highlight the matching .variant_select-product
  $fieldSet.find(".variant_select-product").removeClass("active_seclet");
  $fieldSet
    .find('.variant_select-product[data-title="' + value + '"]')
    .addClass("active_seclet");

  // Find the matching variant input (handle cases like "B1" vs "B1: 70x100 cm")
  var $radioInput = $variantWrapper
    .find(".variant-input-wrap .variant-input")
    .filter(function () {
      var dataValue = $(this).data("value");
      return dataValue === value || dataValue.startsWith(value + ":");
    })
    .find('input[type="radio"]');

  if ($radioInput.length) {
    // Set radio checked and trigger Shopify change event
    $radioInput.click();
    $radioInput.prop("checked", true).trigger("change");

    // Also trigger click on label for styling consistency
    $radioInput.siblings("label").trigger("click");
    
  }

  // ✅ Update the visible selected option text (like “A0” → “B1: 70x100 cm”)
  // Scoped to this wrapper so the quick-shop modal (cloned ids get a -modal
  // suffix) updates its own label, not the main page's.
  $variantWrapper.find('[id^="selected-option-value-"]').first().text(fullText);

  // Scope everything to this product section: the quick-shop modal clones the
  // whole block area, so global selectors would read/write the main page's
  // form (wrong product id in the cart).
  var $productScope = $(this).closest(".product-section");
  if (!$productScope.length) $productScope = $(document);

  // Wait for variant updates to complete
  setTimeout(function () {
    var selectedOptions = [];

    $productScope.find(".variant-input-wrap").each(function () {
      var checked = $(this).find('input[type="radio"]:checked');
      if (checked.length) {
        selectedOptions.push(checked.val().trim());
      }
    });

    var productJsonEl = $productScope.find(
      '[type="application/json"][data-product-json]'
    )[0];
    if (!productJsonEl) return;

    var productData = JSON.parse(productJsonEl.textContent);

    var matchedVariant = productData.variants.find(function (v) {
      return v.options.every(function (opt, i) {
        return opt.trim() === selectedOptions[i];
      });
    });

    if (matchedVariant) {
      $productScope.find('input[name="id"]').val(matchedVariant.id);
    }

  }, 30);



  
});









$(document).ready(function () {
  
  // [data-fancybox="preview"]
  // $('.product-image-main a.fancybox').fancybox({
  //   // Enable zoom feature
  //         buttons: [
  //         "slideShow",
  //         "thumbs",
  //         "zoom",
  //         "close"
  //       ],
  //       loop: false,
  //       protect: false,
  //       width: 750,
  //       height: 750,
  //       // Callback function triggered before zoom
  // });

        function initPopup() {
          var screenWidth = window.innerWidth;
          var $productListInner = $('.product-image-main a.fancybox');
          if (screenWidth <= 740) {
             $productListInner.fancybox({
              // Enable zoom feature
                    buttons: [
                    "slideShow",
                    "thumbs",
                    "zoom",
                    "close"
                  ],
                  loop: true,
                  protect: false,
                width: 750,
        height: 750,
                  // Callback function triggered before zoom
            });
          }else{
            $productListInner.fancybox({
              // Enable zoom feature
                    buttons: [
                    "slideShow",
                    "thumbs",
                    "zoom",
                    "close"
                  ],
                  loop: true,
                  protect: false,
                  // Callback function triggered before zoom
            });
          }
        }

        initPopup();
        $(window).on('resize', initPopup);
})

$( document ).ready(function() {
  if(window.location.href.includes('/products/')){
    $('[name="Border Options"]~.custom-dropdown .dropdown_list [data-title="No Border"]').click();
    $('[name="Border Options"]~.custom-dropdown .dropdown_list [data-title="No Border"]').click();
  }
});


$(document).ready(function() {
    function checkSelectedFrame() {
                var selectedSlide = $('.product-main-slide.is-selected');
                if (selectedSlide.attr('data-frame') === 'frame') {
                   $('.grid--product-images--partial').attr('data-enable-frame', true);
                } else {
                    $('.grid--product-images--partial').attr('data-enable-frame', false);
                }
            }
  var targetNode = document.querySelector('.product-slideshow .flickity-slider'); // Corrected this line
  
  if (targetNode) { 
    var observer = new MutationObserver(function(mutationsList, observer) {
      
      for (var mutation of mutationsList) {
        if (mutation.attributeName === 'class') {
        // checkSelectedFrame();
          break;
        }
      }
    });

    var config = { attributes: true, childList: true, subtree: true };
    observer.observe(targetNode, config);
  } 
  
    var $drawerInner = $('.drawer__inner');
    var $shipInsurance = $('.drawer__footer');
    var isShown = true;
  
    $drawerInner.on('scroll', function () {
        var scrollTop = $drawerInner.scrollTop();
        var scrollHeight = $drawerInner.prop('scrollHeight');
        var innerHeight = $drawerInner.innerHeight();
        var distanceFromBottom = scrollHeight - (scrollTop + innerHeight);

        if (scrollTop > 10 && distanceFromBottom > 100) {
          $('.drawer__footer .ship-insurance, .drawer__footer .additional-checkout-buttons').slideUp()
            // $('.drawer__footer').addClass('drawer__footer--fixed');
          if (isShown) {
            isShown = false;
          }
        } else {
          $('.drawer__footer .ship-insurance, .drawer__footer .additional-checkout-buttons').slideDown()
            // $('.drawer__footer').removeClass('drawer__footer--fixed');
          if (!isShown) {
             isShown = true;
          }
        }
    });
});


// frames and canvas logic starts here

document.addEventListener("DOMContentLoaded", function () {
    const radioCanvas = document.getElementById("radio-canvas");
    const radioPrint = document.getElementById("radio-print");
    const selectedOptionFrame = document.getElementById("selected-option-value-frame");

    const frameVariants = document.querySelectorAll(".amr-Frame .variant-input[data-value]:not([data-value*='Canvas'])");
    const canvasVariants = document.querySelectorAll(".amr-Frame .variant-input-wrap  [data-value*='Canvas']");
    const unframedVariant = document.querySelector(".variant-input[data-value='Unframed']");
    const line_item_parent_effect = document.querySelector(".line-item-parent-effect");
    let noBorderRadio = document.querySelector(".fk-bcpo-radios input[type='radio'][value='No Border']");
    let border_option = document.querySelector(".fk-line-item-parent-effect");
    const canvasLabelText = "Stretched Canvas - No Outside Frame"; // Fixed text for Canvas mode
    let isCanvasActive = false; // Flag to track whether Canvas mode is active

    function selectVariant(variant) {
        if (variant) {
            const input = variant.querySelector("input");
            input.checked = true;
            input.dispatchEvent(new Event("change", { bubbles: true })); // Trigger change event
            
            // If Canvas is active and Unframed is selected, show fixed text
            // if (isCanvasActive && variant.dataset.value === "Unframed") {
            //     updateSelectedOption(canvasLabelText);
            // } else if (!isCanvasActive) {
            //     updateSelectedOption(variant.dataset.value);
            // }
        }
    }

    // function showFrames() {
    //     isCanvasActive = false; // Disable Canvas mode
    //     frameVariants.forEach(variant => (variant.style.display = "inline-block"));
    //     canvasVariants.forEach(variant => (variant.style.display = "none"));
    //     unframedVariant.style.display = "inline-block"; // Ensure Unframed is shown
    //     selectVariant(unframedVariant);
    //     if(border_option){
    //       border_option.style.display = "flex";
    //     }
    //    $('.hidden_canvas_frame').val('');
    // }
  function showFrames() {
    isCanvasActive = false;
    frameVariants.forEach(variant => (variant.style.display = "inline-block"));
    // canvasVariants.forEach(variant => (variant.style.display = "none"));
    if (unframedVariant) {
      unframedVariant.style.display = "inline-block";
    }
    if (border_option) {
      border_option.style.display = "flex";
    }
    $('.hidden_canvas_frame').val('');
    const firstVisibleFrame = $('.amr-Frame .variant-input.var-input')
      .filter(function () {
        return $(this).css('display') === 'inline-block';
      })
      .first()
      .find('input[type="radio"]');
    if (firstVisibleFrame.length) {
      firstVisibleFrame.click();
    }
  }
    function showFramesLoad() {
    isCanvasActive = false;
    frameVariants.forEach(variant => (variant.style.display = "inline-block"));
    // canvasVariants.forEach(variant => (variant.style.display = "none"));
    if (unframedVariant) {
      unframedVariant.style.display = "inline-block";
    }
    if (border_option) {
      border_option.style.display = "flex";
    }
    $('.hidden_canvas_frame').val('');
  }

  function showCanvas() {
      isCanvasActive = true;
      frameVariants.forEach(variant => (variant.style.display = "none"));
      // canvasVariants.forEach(variant => (variant.style.display = "inline-block"));
      selectVariant(unframedVariant);

      if (noBorderRadio && !noBorderRadio.checked) {
        noBorderRadio.checked = true;
        noBorderRadio.dispatchEvent(new Event("change", { bubbles: true }));
        noBorderRadio.click();
      }

      if (border_option) {
        border_option.style.display = "none";
      }

      const firstVisibleCanvasVariant = $('.amr-Frame .variant-input.var-input')
        .filter(function () {
          return $(this).css('display') === 'inline-block';
        })
        .first()
        .find('input[type="radio"]');

      if (firstVisibleCanvasVariant.length) {
        firstVisibleCanvasVariant.click();
      }
    }



    function updateSelectedOption(value) {
      console.log('testr');
        if (selectedOptionFrame) {
            selectedOptionFrame.textContent = value;
        }
    }

    // Handle variant clicks to update label
    document.querySelectorAll(".variant-input").forEach(variant => {
        variant.addEventListener("click", function () {
            if (isCanvasActive && this.dataset.value === "Unframed") {
                updateSelectedOption(canvasLabelText);
            } else if (!isCanvasActive) {
                selectVariant(this);
            }
        });
    });

    showFramesLoad(); // Default state

    if (radioCanvas) {
        radioCanvas.addEventListener("click", showCanvas);
    }
    if (radioPrint) {
        radioPrint.addEventListener("click", showFrames);
    }






});





document.addEventListener("DOMContentLoaded", function () {
  const frameInputs = document.querySelectorAll('input[name="Frame"]');
  const borderInputs = document.querySelectorAll('input[name="Border Options"]');
  const imageGrid2 = document.querySelector(".frame-orientation-wrapper");

  function updateFrameAttributesFrame(selectedInput) {
   setTimeout(() => {
    // Scope to the surrounding product section so the quick-shop modal's
    // cloned picker updates the modal's own gallery, not the main page's.
    const scope = selectedInput?.closest?.(".product-section") || document;
    const inQuickShop = !!selectedInput?.closest?.(".modal--quick-shop");
    const selectedFrame = selectedInput?.value || scope.querySelector('input[name="Frame"]:checked')?.value;
    const selectedBorder = scope.querySelector('.amr-Border .fk-selector-wrapper input:checked')?.value
      || scope.querySelector('.amr-Border .variant_select-product.active_seclet .value_option')?.textContent.trim() || '';
    if (selectedFrame && selectedBorder) {
      const imageGrid = scope.querySelector(".grid--product-images--partial");
      // The live-preview integration keeps its .frame-orientation-wrapper
      // outside the product section — main-page changes must still update it
      // globally (only quick-shop modal changes stay scoped).
      const orientationWrap = scope.querySelector(".frame-orientation-wrapper")
        || (!inQuickShop ? document.querySelector(".frame-orientation-wrapper") : null);

      if (imageGrid) {
        imageGrid.setAttribute("data-enable-frame", true);
        imageGrid.setAttribute("data-border", selectedBorder);
        imageGrid.setAttribute("data-frame", selectedFrame);
      }
      if (orientationWrap) {
        orientationWrap.setAttribute("data-enable-frame", true);
        orientationWrap.setAttribute("data-border", selectedBorder);
        orientationWrap.setAttribute("data-frame", selectedFrame);
      }
    }
    }, 500);
  }

  // Delegated so the quick-shop modal's cloned frame inputs work too
  document.addEventListener("change", function (e) {
    if (e.target.matches && e.target.matches('input[name="Frame"]')) {
      updateFrameAttributesFrame(e.target);
    }
  });

  document.addEventListener("click", function (e) {
    if (e.target.matches && e.target.matches('.fk-selector-wrapper input')) {
      updateFrameAttributesBorder(e.target);
    }
  });


 function updateFrameAttributesBorder(selectedInput) {
    const selectedBorder = selectedInput.value;
    if (selectedBorder) {
      const scope = selectedInput.closest?.(".product-section") || document;
      const inQuickShop = !!selectedInput.closest?.(".modal--quick-shop");
      const imageGrid = scope.querySelector(".grid--product-images--partial");
      const orientationWrap = scope.querySelector(".frame-orientation-wrapper")
        || (!inQuickShop ? document.querySelector(".frame-orientation-wrapper") : null);
      if (imageGrid) {
        imageGrid.setAttribute("data-enable-frame", true);
        imageGrid.setAttribute("data-border", selectedBorder);
      }
      if (orientationWrap) {
        orientationWrap.setAttribute("data-enable-frame", true);
        orientationWrap.setAttribute("data-border", selectedBorder);
      }
    }
  }







  // Run once on page load
  updateFrameAttributesFrame();
});


$(document).on('click', '.cart__remove a', function(e) {
  e.preventDefault();

  const $el = $(this);

  const key = $el.attr('href').match(/id=([^&]+)/)[1];

  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: {
      id: key,
      quantity: 0
    },
    dataType: 'json',
    success: function(cart) {
        if (cart.item_count === 0) {
          $('.shipping-progress-wrapper').hide();
        } else {
          $('.shipping-progress-wrapper').show();
        }
      document.dispatchEvent(new CustomEvent('ajaxProduct:removed', {
        detail: { cart }
      }));

      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: { cart }
      }));
    }
  });
});

$(document).on("click", ".upsell-atc", function() {
  var $btn = $(this);
  var ID = $btn.data('id');

  $btn.addClass('loading').prop('disabled', true);

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: 1,
      id: ID
    },
    dataType: 'json', 
    success: function (data) { 
      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
      $btn.closest('.product-set-wrapper').hide();
      $btn.removeClass('loading').prop('disabled', false);
      if ($('.drawer__footer .product-set-wrapper:visible').length === 0) {
        $('.custom-accordion').hide();
    }

    },
    error: function() {
      $btn.removeClass('loading').prop('disabled', false);
    }
  });
});


document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".view-properties-btn").forEach(btn => {
    btn.addEventListener("click", function () {
      const key = this.getAttribute("data-item-key");
      document.getElementById("properties-" + key).style.display = "block";
    });
  });

  document.querySelectorAll(".close-modal").forEach(closeBtn => {
    closeBtn.addEventListener("click", function () {
      this.closest(".properties-modal").style.display = "none";
    });
  });

  // Close modal on outside click
  window.addEventListener("click", function (e) {
    if (e.target.classList.contains("properties-modal")) {
      e.target.style.display = "none";
    }
  });
});




// $(document).ready(function() {
//   // Wait for variant inputs to exist
//   const checkFirstOption = setInterval(() => {
//     const firstOption = $('.variant-input-wrap.size_opt input[type="radio"]').first();
//     if (firstOption.length) {
//         $('.variant-input-wrap.size_opt label').click();
//       firstOption.trigger('click');
//       clearInterval(checkFirstOption);
//     }
//   }, 200);
// });





function initFkBorderSync() {
  // Border options UI is radios-only: the White Border dropdown and the
  // "Border Options: <value>" label line are no longer rendered
  // (snippets/size_option.liquid), and the BORDER OPTIONS heading stays
  // visible. Radio events are delegated so the quick-shop modal's cloned
  // markup works too, and everything is scoped to the surrounding
  // .product-section so modal and page never write into each other's form.
  document.addEventListener("change", function (e) {
    if (!e.target.matches || !e.target.matches(".fk-bcpo-radios input[type='radio']")) return;
    const fkRadio = e.target;
    const scope = fkRadio.closest(".product-section") || document;
    const value = fkRadio.value.trim();

    // Map fake radio text -> real variant value ("White Border" -> "With White Border")
    const realValue = value === "White Border" ? "With White Border" : value;

    const labelValue = fkRadio.closest(".fk-selector-wrapper")?.querySelector(".fk-bcpo-value");
    if (labelValue) labelValue.textContent = value;

    // Sync with the real Shopify variant input in the same product section
    const realRadio = scope.querySelector(
      `.variant-input-wrap input[type='radio'][value="${CSS.escape(realValue)}"]`
    );
    if (realRadio && !realRadio.checked) {
      realRadio.checked = true;
      realRadio.dispatchEvent(new Event("change", { bubbles: true }));
    }
  });

  function applyDefault(scope) {
    const defaultRadio = scope.querySelector(
      ".fk-bcpo-radios input[type='radio'][value='No Border']"
    );
    if (defaultRadio && !defaultRadio.checked) {
      defaultRadio.checked = true;
      defaultRadio.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  // Default: auto-select "No Border" on the main page
  applyDefault(document);

  // Same default when a quick-view modal finishes loading its blocks
  document.addEventListener("quickview:loaded", function (e) {
    const modal = document.getElementById("QuickShopModal-" + e.detail.productId);
    if (modal) applyDefault(modal);
  });
}

// Run once on load
document.addEventListener("DOMContentLoaded", initFkBorderSync);





